import { connect } from 'react-redux';

import Notifications from './Notifications';
import {
  notificationsListMetaSelector,
  notificationsListSelector,
  isLoadingNotificationsSelector,
} from '../../../../store/selectors/notifications';
import {
  deleteNotificationsAction,
  goToNotificationEntityAction,
  readNotificationsAction,
} from '../../../../store/actions/notifications';
import { setNotificationsPage } from '../../../../store/reducers/notifications';

const mapStateToProps = state => ({
  notifications: notificationsListSelector(state),
  notificationsMeta: notificationsListMetaSelector(state),
  isLoading: isLoadingNotificationsSelector(state),
});

const mapDispatchToProps = {
  setNotificationsPage,
  readNotifications: readNotificationsAction,
  deleteNotifications: deleteNotificationsAction,
  goToNotificationEntity: goToNotificationEntityAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
